import { useState } from "react";

import { useTranslator } from "@/i18n/useTranslator";
import { HeaderButton } from "@/src/blocks/HeaderButton";
import { NewCustomerForm } from "@/src/components/admin/NewCustomerForm";
import { RightPanel } from "@/src/components/RightPanel";

export const CustomersPageHeaderButton = () => {
  const [isPanelOpen, setIsPanelOpen] = useState(false);
  const { t } = useTranslator();

  return (
    <>
      <RightPanel
        controlledOpen={isPanelOpen}
        setControlledOpen={setIsPanelOpen}
        title={t("new_customer_form.title")}
        content={
          <div className="m-4">
            <NewCustomerForm onSuccess={() => setIsPanelOpen(false)} />
          </div>
        }
        onDrawerClosed={() => setIsPanelOpen(false)}
      />
      <HeaderButton
        buttons={[
          {
            i18nKey: "new_customer_form.title",
            handleOnClick: () => setIsPanelOpen(true),
            icon: "Plus",
          },
        ]}
      />
    </>
  );
};
